import { isShortProductionDowntime } from "../../../shared/production/downtime";
import type { ProductionReason, ProductionRun } from "./models";

/** Returns durable catalogue ids, ranked by observed non-short downtime use. */
export function commonDowntimeReasonIds(runs: readonly ProductionRun[], reasons: readonly ProductionReason[], maximum = 6): string[] {
  const catalogue = new Set(reasons.filter((reason) => reason.category === "DOWNTIME").map((reason) => reason.id));
  const counts = new Map<string, { count: number; latest: number }>();
  for (const downtime of runs.flatMap((run) => run.downtimes)) {
    if (!downtime.reasonCodeId || !catalogue.has(downtime.reasonCodeId) || isShortProductionDowntime(downtime)) continue;
    const current = counts.get(downtime.reasonCodeId) ?? { count: 0, latest: Number.NEGATIVE_INFINITY };
    current.count += 1;
    current.latest = Math.max(current.latest, Date.parse(downtime.endedAt ?? downtime.startedAt));
    counts.set(downtime.reasonCodeId, current);
  }
  const ranked = [...counts.entries()]
    .sort(([leftId, left], [rightId, right]) => right.count - left.count || right.latest - left.latest || leftId.localeCompare(rightId, "tr"))
    .slice(0, maximum)
    .map(([id]) => id);
  const summaryIds = runs.flatMap(run => run.terminalSummary?.recentReasonIds ?? []).filter(id => catalogue.has(id));
  return [...new Set([...summaryIds, ...ranked])].slice(0, maximum);
}
